import { handleThrownError } from '@/common/errors/handleThrownError';
import type { MarketplaceUser, MarketplaceUserPayload } from '@/types';

export async function transformUserData(
  userPayload: MarketplaceUserPayload,
): Promise<MarketplaceUser> {
  try {
    return {
      user: {
        id: userPayload.user.id,
        username: userPayload.user.username,
        email: userPayload.user.email,
        firstName: userPayload.user.first_name,
        lastName: userPayload.user.last_name,
        isStaff: userPayload.user.is_staff,
        isActive: userPayload.user.is_active,
      },
      company: {
        id: userPayload.company.id,
        name: userPayload.company.name,
        shortName: userPayload.company.shortname,
        companyUrl: userPayload.company.company_url,
        currency: userPayload.company.currency,
        phone: userPayload.company.phone,
        alternatePhone: userPayload.company.alternate_phone,
        fax: userPayload.company.fax,
        email: userPayload.company.email,
        billingName: userPayload.company.billing_name,
        billingEmail: userPayload.company.billing_email,
        isFhdnAffiliateEnabled: userPayload.company.is_fhdn_affiliate_enabled,
        isFhdnApiAffiliateEnabled:
          userPayload.company.is_fhdn_api_affiliate_enabled,
        isFhdnApiProviderEnabled:
          userPayload.company.is_fhdn_api_provider_enabled,
        isFhdnProviderEnabled: userPayload.company.is_fhdn_provider_enabled,
      },
      createdAt: userPayload.created_at,
      modifiedAt: userPayload.modified_at,
      inFhdn: userPayload.in_fhdn,
      inFhdnApi: userPayload.in_fhdn_api,
    };
  } catch (error) {
    handleThrownError({
      error,
      toastMessage: 'Unexpected error occurred, please try again.',
      log: true,
    });
    throw error;
  }
}
